import { Component, OnInit, ViewChild } from "@angular/core";
import { BatchService } from "../../qrcode/batchstamp/batch.service";
import { ActivatedRoute, Params } from "@angular/router";
import { moment } from "ngx-bootstrap/chronos/test/chain";
import { LogsService } from "../logs/logs.service";
import { ModalCancelStampComponent } from "../../qrcode/popup/modalCancelStamp.component";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";
import { number } from "ng2-validation/dist/number";
import { ImageService } from "../../../imageService";
import { FormBuilder } from "@angular/forms";
import { CheckStampService } from "./services/check-stamp.service";
declare var $: any;

@Component({
  selector: "find_stamp_mb_by_serial",
  templateUrl: "find-stamp-mb-by-serial.template.html",
  styleUrls: ["./find-stamp-mb-by-serial.component.css"],
  providers: [
    BatchService,
    LogsService,
    EvsStampService,
    ImageService,
    CheckStampService,
  ],
})
export class FindStampMbBySerialComponent implements OnInit {
  // loại tem : 1 là tem thung, 0 là tem san pham
  type_stamp: number;
  data_stamp;
  data: any = {};

  listDistribution: any = [];
  logsScan: any = [];
  logsScanGuarantee: any = [];

  code: any; //3BuXds5
  loading_page: boolean = false;
  message: string = "";
  has_data: boolean = false;

  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";

  serial: string = "";
  public logs_TH: any = {
    currentPage: 1,
    page_size: 10,
    current_filter: {},
    has_list: false,
  };
  public logs_CG: any = {
    currentPage: 1,
    page_size: 10,
    current_filter: {},
    has_list: false,
  };
  public logs_BH: any = {
    currentPage: 1,
    page_size: 10,
    current_filter: {},
    has_list: false,
  };

  bsModalRef: BsModalRef;
  @ViewChild("box") box;
  @ViewChild("product") product;
  constructor(
    private batchService: BatchService,
    private activatedRoute: ActivatedRoute,
    private logsService: LogsService,
    private modalService: BsModalService,
    private evsStamp: EvsStampService,
    private imageService: ImageService,
    private fb: FormBuilder,
    private checkStampService: CheckStampService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      console.log(params);
      console.log(params.token);

      if (params.token) {
        localStorage.setItem("Access-Token-2", params.token);
        if (params.code) {
            this.code = params.code;
            this.getDetailStampById();
          }
      }
    });
  }
  getDetailStampById() {
    const code = this.code.trim();
    if (code) {
      if (code.split("-").length < 2) {
        this.has_data = false;
        this.message = "Mã tem không đúng định dạng";
        this.type_stamp = 3;
        return;
      }
      const keys = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      const id = code.split("-")[code.split("-").length - 1].split("");
      let invalid = false;
      id.map((i) => {
        // tslint:disable-next-line:radix
        if (!keys.includes(parseInt(i))) {
          invalid = true;
        }
      });
      if (invalid) {
        this.has_data = false;
        this.message = "Mã tem không đúng định dạng";
        this.type_stamp = 3;
        return;
      }

      this.loading_page = true;
      this.checkStampService.getDetail(code.toUpperCase()).subscribe(
        (res) => {
          this.loading_page = false;
          // 0 la tem san pham , 1 la tem thung
          if (res.code === 1) {
            this.has_data = true;
            const data = res.data;
            // tslint:disable-next-line:radix
            this.type_stamp = parseInt(data.bundleType);
            this.data_stamp = data;
            let serial = this.data_stamp.serial;
            serial = serial.split("-");
            this.data_stamp.prefix = serial[0];
            this.data_stamp.idStart = serial[1];
            // this.type_stamp = 1;
            setTimeout(() => {
              if (this.type_stamp === 0) {
                this.product.loadData(this.data_stamp);
                return;
              }
              if (this.type_stamp === 1) {
                this.box.loadData(this.data_stamp);
                return;
              }
            }, 500);
            return;
          }
          this.type_stamp = undefined;
          this.has_data = false;
          this.message = res.message;
        },
        (error) => {
          this.loading_page = false;
          this.has_data = false;
          this.message = error.message;
          this.type_stamp = undefined;
        }
      );
    }
  }
  findCode() {
    let code: string = this.code.trim();
    if (code) {
      this.loading_page = true;
    }
    if (code) {
      this.batchService
        .findStamp(code)
        .toPromise()
        .then((res: any) => {
          this.loading_page = false;
          if (res.error == false) {
            this.has_data = true;
            let data_ = res.data;
            let batch = res.data.batch;
            let verified = res.data.first_verified;
            // console.log(batch.number);
            let serial = this.formatSerial(batch.number, batch.prefix);
            this.serial = serial;
            this.getLogsDistributionBySerial({});
            this.getLogsScanBySerial();
            this.getLogsGuarantee();

            let arr_services = this.convertServiceToText(batch.services);
            let diachi: string = "";
            if (verified.address) {
              diachi += diachi ? ", " + verified.address : verified.address;
            }
            if (verified.district_name) {
              diachi += diachi
                ? ", " + verified.district_name
                : verified.district_name;
            }
            if (verified.city_name) {
              diachi += diachi ? ", " + verified.city_name : verified.city_name;
            }

            this.data = {
              serial: serial,
              c_serial: batch.c_serial,
              qri: batch.qri,
              c_qri: batch.c_qri,
              qrm: batch.qrm,
              c_qrm: batch.c_qrm,
              sms: batch.sms,
              c_sms: batch.c_sms,
              status: data_.status,
              batch_id: batch.id,
              batch_name: batch.name,
              prefix: batch.prefix,
              number: batch.number,
              batch_status: batch.status,
              arr_services: arr_services,
              has_chonggia: this.checkService(
                batch.services,
                this.code_chonggia
              ),
              has_baohanh: this.checkService(batch.services, this.code_baohanh),
              has_tranhang: this.checkService(
                batch.services,
                this.code_tranhang
              ),
              active_time: batch.active_time,
              active_time_f: moment(batch.active_time).format("DD/MM/YYYY"),
              product_id: batch.product_id,
              product_name: batch.product_name,
              product_image: this.imageService.readSrcImage(
                batch.product_image,
                "thumb_medium"
              ),

              s_name: verified.name ? verified.name : null,
              s_phone: verified.phone ? verified.phone : null,
              s_email: verified.email ? verified.email : null,
              s_city: verified.city_name ? verified.city_name : null,
              diachi: diachi,
              device: verified.user_agent ? verified.user_agent : null,
              verified_time: verified.ins_dt
                ? moment(verified.ins_dt).format("DD/MM/YYYY")
                : null,
              is_verified: JSON.stringify(verified) != "{}",
            };
            // console.log(JSON.stringify(verified)!="{}");
          } else {
            this.has_data = false;
            this.message = res.message
              ? res.message
              : "Không tìm thấy thông tin tem";
            console.log("findStamp:error", res);
          }
        })
        .catch((err: any) => {
          this.has_data = false;
          this.message = err.message
            ? err.message
            : "Không tìm thấy thông tin tem";
          this.loading_page = false;
          console.log("findStamp:catch", err);
        });
    }
  }

  checkService(services_list: string, code_service: any) {
    if (services_list.indexOf(code_service.toString()) != -1) {
      return true;
    }
    return false;
  }

  getLogsDistributionBySerial(request: any = null) {
    let data_get: any = request ? request : this.logs_TH.current_filter;
    if (this.logs_TH.currentPage < 0) {
      this.logs_TH.currentPage = 1;
    }

    data_get.offset =
      this.logs_TH.page_size *
      (this.logs_TH.currentPage <= 0 ? 0 : this.logs_TH.currentPage - 1);
    data_get.limit = this.logs_TH.page_size;
    data_get.sort_by = "created_time:desc";
    data_get.serial = this.serial;

    this.batchService
      .getDistribution(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list: Array<any> = [];
          if (res.data.logs.length > 0) {
            this.logs_TH.has_list = true;
            for (let _data of res.data.logs) {
              let obj = {
                created_time: moment(_data.created_time).format("DD/MM/YYYY"),
                store_id: _data.store_id,
                store_name: _data.store_name,
                city_name: _data.city,
                district_name: _data.district,
                address: _data.address,
              };
              list.push(obj);
            }
          }
          this.listDistribution = list;
        } else {
          console.log("getLogsDistributionBySerial:error", res);
        }
      })
      .catch((err: any) => {
        console.log("getLogsDistributionBySerial:catch", err);
      });
  }

  setPageTH(page: number) {
    if (page < 1) {
      this.logs_TH.currentPage = 1;
      return;
    }
    if (page !== this.logs_TH.currentPage) {
      this.logs_TH.currentPage = page;
      this.getLogsDistributionBySerial();
    }
  }

  goPageTH(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageTH(toPage);
    } else {
      this.setPageTH(1); //toPage = 1;
    }
  }

  getLogsScanBySerial(request: any = null) {
    let data_get: any = request ? request : this.logs_CG.current_filter;
    if (this.logs_CG.currentPage < 0) {
      this.logs_CG.currentPage = 1;
    }

    data_get.offset =
      this.logs_CG.page_size *
      (this.logs_CG.currentPage <= 0 ? 0 : this.logs_TH.currentPage - 1);
    data_get.limit = this.logs_TH.page_size;
    data_get.sort_by = "ins_dt:desc";
    data_get.serial = this.serial;

    this.logsService
      .getLogsScan(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list: Array<any> = [];
          if (res.data.length && res.data.length > 0) {
            this.logs_CG.has_list = true;
            for (let _data of res.data) {
              let response_f = "";
              if (_data.response == "active") {
                response_f = "Xác thực";
              } else if (_data.response == "warning") {
                response_f = "Cảnh báo";
              } else {
                response_f = "Quét kiểm tra thông tin";
              }
              let type_f: string = "";
              if (_data.type == "sms") {
                type_f = "Nhắn tin SMS";
              } else if (_data.type == "qrm") {
                type_f = "Quét mã hở";
              } else if (_data.type == "qri") {
                type_f = "Quét mã phủ cào";
              } else {
                type_f = "không xác định";
              }
              let khuvuc = "";
              if (_data.district) {
                khuvuc += khuvuc ? " - " + _data.district : "";
              }
              if (_data.city) {
                khuvuc += khuvuc ? " - " + _data.city : "";
              }
              // console.log(khuvuc);
              let obj = {
                created_time: moment(_data.ins_dt).format("DD/MM/YYYY"),
                response: _data.response,
                response_f: response_f,
                type_f: type_f,
                khuvuc: khuvuc,
                address: _data.address,
              };
              list.push(obj);
            }
          }
          this.logsScan = list;
        } else {
          console.log("getLogsScanBySerial:error", res);
        }
      })
      .catch((err: any) => {
        console.log("getLogsScanBySerial:catch", err);
      });
  }

  setPageCG(page: number) {
    if (page < 1) {
      this.logs_CG.currentPage = 1;
      return;
    }
    if (page !== this.logs_CG.currentPage) {
      this.logs_CG.currentPage = page;
      this.getLogsDistributionBySerial();
    }
  }

  goPageCG(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageCG(toPage);
    } else {
      this.setPageCG(1); //toPage = 1;
    }
  }

  getLogsGuarantee(request: any = null) {
    let data_get: any = request ? request : this.logs_CG.current_filter;
    if (this.logs_CG.currentPage < 0) {
      this.logs_CG.currentPage = 1;
    }

    // data_get.offset = this.logs_CG.page_size * (this.logs_CG.currentPage <= 0 ? 0 : this.logs_TH.currentPage - 1);
    // data_get.limit = this.logs_TH.page_size;
    // data_get.sort_by = 'created_time:desc';
    // data_get.serial = this.serial;

    this.evsStamp
      .getLogGuaranteeBySerial(this.serial, { offset: 0, limit: 100 })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list: Array<any> = [];
          if (res.data.logs && res.data.logs.length > 0) {
            this.logs_BH.has_list = true;
            for (let _data of res.data.logs) {
              console.log(_data);
              let obj = {
                created_time: moment(_data.created_time).format("DD/MM/YYYY"),
                type_log: _data.status.id,
                type_log_f: _data.status.name,
                state: _data.state ? _data.state.id : 0,
                state_f: _data.state ? _data.state.name : "",
                name:
                  _data.customer && _data.customer.name
                    ? _data.customer.name
                    : null,
                phone:
                  _data.customer && _data.customer.phone
                    ? _data.customer.phone
                    : null,
                email:
                  _data.customer && _data.customer.email
                    ? _data.customer.email
                    : null,
                address:
                  _data.customer && _data.customer.address
                    ? _data.customer.address
                    : null,
                district_name:
                  _data.customer && _data.customer.district_name
                    ? _data.customer.district_name
                    : null,
                city_name:
                  _data.customer && _data.customer.city_name
                    ? _data.customer.city_name
                    : null,
              };
              list.push(obj);
            }
          }
          this.logsScanGuarantee = list;
        } else {
          console.log("getLogsScanBySerial:error", res);
        }
      })
      .catch((err: any) => {
        console.log("getLogsScanBySerial:catch", err);
      });
  }
  setPageBH(page: number) {
    if (page < 1) {
      this.logs_BH.currentPage = 1;
      return;
    }
    if (page !== this.logs_BH.currentPage) {
      this.logs_BH.currentPage = page;
      this.getLogsDistributionBySerial();
    }
  }

  goPageBH(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageBH(toPage);
    } else {
      this.setPageBH(1); //toPage = 1;
    }
  }

  showPopupCancelStamp(data: any) {
    let detail = {
      name: data.batch_name,
      id: data.batch_id,
      id_start: data.number,
      id_end: data.number,
      prefix: data.prefix,
      readonly: true,
    };
    const initialState = {
      batch_detail: detail,
    };
    this.bsModalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = "Bỏ qua";
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: "Chống giả" });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: "Bảo hành" });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: "Tràn hàng" });
    }
    return arr_services;
  }

  formatSerial(number, prefix: string = "") {
    let format_serial: string = "không xác định";
    if (number) {
      let prefix2 = prefix ? prefix + "-" : "";
      number = number.toString();
      if (number.length > 6) {
        format_serial = prefix2 + number;
      } else {
        let pad = "000000";
        format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
      }
    }
    return format_serial;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list_mb/find-stamp-mb-by-serial.component.ts